<template>
    <div class="flex flex-col justify-between min-h-screen">
        <slot></slot>
    </div>
</template>
